export const updateAppPage = (payload: { id: number, name?: string, description?: string, isHidden?: boolean, icon?: any }) => ({
    type: "@saga/UPDATE_APP_PAGE",
    payload
});